import React, { useState } from 'react';
import Container from 'container';
import Headline from 'headline';
import 'swiper/dist/css/swiper.css';
import axios from 'axios';
import '@firebase/database';
import Button from 'button';
import Icon from 'icon';
import { useFormInput, useErrors, useSubmitReady } from 'hooks/useForm';
import Input from 'shared/form-input';
import Checkbox from 'shared/form-checkbox';
import Validations from './validate';
import s from './questions_form.module.scss';

export default function QForm({
  headline,
  small_text,
  submit_button,
  ...props
}) {
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [connectionError, setConnectionError] = useState(false);

  const name = useFormInput('');
  const email = useFormInput('');
  const subject = useFormInput('');
  const message = useFormInput('');
  const [checked, setChecked] = useState(true);

  const nameError = useErrors({ name: name.state }, Validations);
  const emailError = useErrors({ email: email.state }, Validations);
  const subjectError = useErrors({ subject: subject.state }, Validations);
  const messageError = useErrors({ message: message.state }, Validations);

  const submitReady = useSubmitReady(
    {
      name: name.state,
      email: email.state,
      subject: subject.state,
      message: message.state
    },
    Validations
  );

  const resetForm = () => {
    name.setters.setValue('');
    name.setters.setTouched(false);
    name.setters.setBlurred(false);

    email.setters.setValue('');
    email.setters.setTouched(false);
    email.setters.setBlurred(false);

    subject.setters.setValue('');
    subject.setters.setTouched(false);
    subject.setters.setBlurred(false);

    message.setters.setValue('');
    message.setters.setTouched(false);
    message.setters.setBlurred(false);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      name: name.state.value,
      email: email.state.value,
      subject: subject.state.value,
      message: message.state.value,
      date: new Date().toDateString(),
      page: window.location.pathname,
      newsletterSignUp: checked,
    };
    resetForm();
      console.log(payload);
    try {
      const res = await axios.post(
        'https://furlough-main.firebaseio.com/questions.json',
        payload
      );
      setSuccess(true);
      setTimeout(() => setSuccess(false), 5000);
      setLoading(false);
    } catch (error) {
      console.log('error', error);
      setConnectionError(true);
      setTimeout(() => setConnectionError(false), 5000);
      setLoading(false);
    }
  };

  const buttonContent = () => {
    if (loading) {
      return (
        <span className={s.spinner}>
          <Icon icon="spinner" className="animate-spin" />
        </span>
      );
}
    if (success) return 'Success!';
    return 'Submit';
  };


  return (
    <Container className={s.root}>
      <Headline className={s.headline} html={headline} />
      <form className={s.form} onSubmit={handleSubmit}>
        <div className={s.column1}>
          <p>Full Name</p>
          <Input
            className={s.formInput}
            error={nameError.name}
            {...name.events}
            value={name.state.value}
            type="text"
            name="name"
          />

          <p>Email</p>
          <Input
            className={s.formInput}
            error={emailError.email}
            {...email.events}
            value={email.state.value}
            type="text"
            name="email"
          />

          <p>Subject</p>
          <Input
            className={s.formInput}
            error={subjectError.subject}
            {...subject.events}
            value={subject.state.value}
            type="text"
            name="subject"
          />
        </div>
        <div className={s.column4}>
          <div className={s.column2}>
            <p>Message</p>
            <Input
              className={s.textarea}
              error={messageError.message}
              {...message.events}
              value={message.state.value}
              textarea
              type="text"
              name="message"
            />
          </div>

          <div className={s.cloumn3}>
            <Checkbox
              checked={checked}
              setChecked={setChecked}
            >
                      Sign up to our newsletter.
            </Checkbox>
            <Button className={s.submit} disabled={!submitReady} type="submit">
              {buttonContent()}
            </Button>
            {connectionError && (
            <p className="error">
            There was an error processing your request, please try again in a
            few minutes.
            </p>
        )}
          </div>
        </div>

      </form>
    </Container>
  );
}
